const header = {
  '.kuiper-popover-base': {
    marginLeft: '5px',
    position: 'absolute!important',
    '.kuiper-icon-wrapper': {
      top: '-2px',
    },
  },
}

const body = {
  height: 22,
  span: {
    float: 'left',
  },
}

const shiftDays = {
  float: 'left',
  margin: '0 7px',
  width: 50,
  input: {
    top: 0,
  },
}

const shiftDirection = {
  float: 'left',
  marginLeft: 7,
  '.kuiper-select-trigger': {
    height: 22,
    textTransform: 'none',
    top: '-1px',
  },
}

export const styles = {
  body,
  header,
  shiftDays,
  shiftDirection,
}
